import reuqest from "@/utils/request";
import axios from "axios";
const newCrmUrl = 'https://heygood-engine.xmheigu.com/ai-engine/'
const cancelRequst: { [propName: string]: any } = {};
const service = {
    cancelRequest: (key: string) => {
        cancelRequst[key] && cancelRequst[key]();
    },
    smsVerifyCode: (params: any) => reuqest({
        url: '/heygood-crm/sale/outApi/FeiYuCallBack/sendNoteVerifyCode',
        method: 'GET',
        params,
        cancelToken: new axios.CancelToken((cancel) => {
            cancelRequst['sendNoteVerifyCode'] = cancel;
        })
    }),
    submitRegister: (data: any) => reuqest({
        url: '/heygood-crm/sale/outApi/FeiYuCallBack/syncCommonRegisterData',
        method: 'POST',
        data,
        cancelToken: new axios.CancelToken((cancel) => {
            cancelRequst['syncCommonRegisterData'] = cancel;
        })
    }),
    //查询客户案例
    getCases: async ({ pageNo = 1, pageSize = 12 }) => {
        const res = await reuqest({
            url: '/heygood-crm/api/website/webCaseItem/list',
            method: 'GET',
            params: { pageNo, pageSize },
            cancelToken: new axios.CancelToken((cancel) => {
                cancelRequst['sendNoteVerifyCode'] = cancel;
            })
        })
        return res.data.result
    },
    // 文章标签
    getNewsLabel: async () => {
        const res = await reuqest({
            url: '/heygood-crm/api/website/webInformation/getDict',
            method: 'GET',
            params: {},
            cancelToken: new axios.CancelToken((cancel) => {
                cancelRequst['sendNoteVerifyCode'] = cancel;
            })
        })
        return res.data.result
    },
    // 资讯列表
    getNews: async ({ informationType = '', pageNo = 1, pageSize = 20 }) => {
        const res = await reuqest({
            url: '/heygood-crm/api/website/webInformation/list',
            method: 'GET',
            params: { informationType, pageNo, pageSize },
            cancelToken: new axios.CancelToken((cancel) => {
                cancelRequst['sendNoteVerifyCode'] = cancel;
            })
        })
        return res.data.result
    },
    //资讯详情
    getNewDetail: async (id: any) => {
        const res = await reuqest({
            url: '/heygood-crm/api/website/webInformation/detail',
            method: 'GET',
            params: { id },
            cancelToken: new axios.CancelToken((cancel) => {
                cancelRequst['sendNoteVerifyCode'] = cancel;
            })
        })
        return res.data.result
    },
    //新CRM获取图形验证码
    newCrmVerifyCode: (params: any) => reuqest({
        baseURL: newCrmUrl,
        url: `crm/register/randomImage/${params.tenantId}/${params.key}`,
        method: 'GET',
        params: null
    }),
    //新CRM获取短信
    newCrmSmsVerifyCode: (params: any) => reuqest({
        baseURL: newCrmUrl,
        url: 'crm/register/sendPhoneCode',
        method: 'POST',
        data: params,

    }),
    //新CRM获取短信
    newCrmRegister: (params: any) => reuqest({
        baseURL: newCrmUrl,
        url: 'crm/register',
        method: 'POST',
        data: params,

    }),
};

export default service;
